import { PayerEngagement } from "@wingspanhq/wingspan-api-sdk";

/**
 * The assignments worth listing: everything except the account's default
 * engagement and anything flagged as a duplicate.
 *
 * The v3 replacement for calling `selectorPayerPayeeEngagements(…, false, true)`
 * on adapted v1 engagements. The duplicate flag lives in `metadata` on v3, where
 * v1 carried a typed `labels.duplicate`; metadata values are strings, so the
 * comparison is against `"true"`.
 */
export const selectorNamedPayerEngagements = (
  engagements: PayerEngagement[]
): PayerEngagement[] =>
  engagements.filter(
    engagement =>
      !engagement.isDefault && engagement.metadata?.duplicate !== "true"
  );
